/******************************************
*  Author : Riccardo Di Dato
*  Created On : Mon May 23 2022
*  File : SimpleEventHandler.ts
*******************************************/
import { DOMEventHandlerMockMixin } from "./mixin.js";
export class DOMSimpleEventHandlerMock extends DOMEventHandlerMockMixin(class base {
}) {
}
